// AGC: MaquinarioSettings - Sub-page of Settings > Sistema > Tipos de Maquinário
// AGC: Manages built-in + custom machinery category list (shared with AddMachine picker).

import React, { useMemo } from 'react'
import { Truck } from 'lucide-react'
import { CustomListSettingsPage } from './CustomListSettingsPage'
import { useTranslation } from '../../hooks/useTranslation'
import { MACHINE_CATEGORIES } from '../../types/machine'
import type { CustomListItem } from '../inventory/ManageCategoriesUnitsModal'
import type { Screen } from '../../types'

// AGC: Shared storage key — must match the one read by AddMachine and other consumers
export const STORAGE_KEY_CUSTOM_MACHINERY_TYPES = 'droidfarm_custom_machinery_types'

interface MaquinarioSettingsProps {
  onBack: () => void
  onNavigate: (screen: Screen) => void
}

export const MaquinarioSettings: React.FC<MaquinarioSettingsProps> = ({ onBack }) => {
  const { t } = useTranslation()

  const builtInItems = useMemo<CustomListItem[]>(
    () => MACHINE_CATEGORIES.map((c) => ({ id: c.id, label: `${c.icon} ${c.name}` })),
    []
  )

  return (
    <CustomListSettingsPage
      title={t('profile.settingsMachineryTypes')}
      defaultSectionTitle={t('profile.customListDefault')}
      customSectionTitle={t('profile.customListCustom')}
      emptyText={t('profile.customListEmpty')}
      addPlaceholder={t('profile.settingsMachineryTypes')}
      builtInItems={builtInItems}
      storageKeyPrefix={STORAGE_KEY_CUSTOM_MACHINERY_TYPES}
      onBack={onBack}
      Icon={Truck}
    />
  )
}
